module.exports = __webpack_public_path__ + "components/home-header/static/header-4--huge-2b6cba4d558944e05a9931ba5d286a05.jpg";